import script from "./routTree.vue?vue&type=script&setup=true&lang=ts"
export * from "./routTree.vue?vue&type=script&setup=true&lang=ts"

import "./routTree.vue?vue&type=style&index=0&id=0f4b6f28&scoped=true&lang=scss"
import "./routTree.vue?vue&type=style&index=1&id=0f4b6f28&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f4b6f28"]])

export default __exports__